import * as React from "react"

// Single source of truth for Root's customer-facing residential numbers.
export const AUSTIN_RESIDENTIAL_E164 = "+15122225423"
export const DFW_RESIDENTIAL_E164 = "+14698954313"

export interface LocalPhone {
  e164: string
  href: string
  pretty: string
}

const formatPretty = (e164: string): string => {
  const digits = (e164 || "").replace(/\D/g, "")
  const ten =
    digits.length === 11 && digits.startsWith("1")
      ? digits.slice(1)
      : digits
  if (ten.length !== 10) return e164
  return `(${ten.slice(0, 3)}) ${ten.slice(3, 6)}-${ten.slice(6)}`
}

export const toLocalPhone = (e164?: string): LocalPhone => {
  const value = e164 || AUSTIN_RESIDENTIAL_E164
  return {
    e164: value,
    href: `tel:${value}`,
    pretty: formatPretty(value),
  }
}

const LocalPhoneContext = React.createContext<LocalPhone>(
  toLocalPhone(AUSTIN_RESIDENTIAL_E164)
)

export const LocalPhoneProvider: React.FC<{
  e164?: string
  children: React.ReactNode
}> = ({ e164, children }) => (
  <LocalPhoneContext.Provider value={toLocalPhone(e164)}>
    {children}
  </LocalPhoneContext.Provider>
)

export const useLocalPhone = (): LocalPhone =>
  React.useContext(LocalPhoneContext)
